import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Edit: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M23.546 3.936a3.195 3.195 0 0 1 4.518 4.518L10.578 25.94a6.388 6.388 0 0 1-2.693 1.605L3 29l1.455-4.884a6.389 6.389 0 0 1 1.605-2.694L23.546 3.936ZM7.35 22.713a4.564 4.564 0 0 0-1.147 1.924l-.492 1.65 1.65-.491a4.564 4.564 0 0 0 1.925-1.147L24.073 9.861l-1.935-1.936L7.35 22.713ZM26.774 5.226a1.37 1.37 0 0 0-1.938 0l-1.408 1.409 1.936 1.936 1.41-1.408a1.37 1.37 0 0 0 0-1.937Z"
    />
  </Icon>
);
